import { PaginationProps as AntPaginationProps } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import {
  HiChevronDoubleLeft,
  HiChevronDoubleRight,
  HiChevronLeft,
  HiChevronRight,
  HiEllipsisHorizontal,
} from 'react-icons/hi2';
import { withTheme } from '../ThemeProvider';
import { Container, StyledPagination } from './styles';
import { PaginationProps } from './types';

const PaginationComponent: React.FC<PaginationProps> = props => {
  const [current, setCurrent] = useState(props.defaultCurrent || 1);

  const lastPage = useMemo(() => {
    return Math.ceil((props.total || 0) / (props.pageSize || 10));
  }, [props.total, props.pageSize]);

  const onChange = (page: number) => {
    setCurrent(page);
    if (props.onChange) {
      props.onChange(page, props.pageSize || 10); // Default to 10 if pageSize is undefined
    }
  };

  useEffect(() => {
    if (props.current) {
      setCurrent(props.current);
    }
  }, [props.current]);

  const itemRender: AntPaginationProps['itemRender'] = (_, type, originalElement) => {
    switch (type) {
      case 'prev':
        return (
          <div className="icon">
            <HiChevronLeft width={16} height={16} />
          </div>
        );

      case 'next':
        return (
          <div className="icon">
            <HiChevronRight width={16} height={16} />
          </div>
        );

      case 'jump-prev':
      case 'jump-next':
        return (
          <div className="icon ellipsis">
            <HiEllipsisHorizontal width={16} height={16} />
          </div>
        );

      default:
        return originalElement;
    }
  };

  const handleFirstPage = () => {
    onChange(1);
  };
  const handleLastPage = () => {
    onChange(lastPage);
  };

  return (
    <Container>
      <button className="icon" disabled={current <= 1} onClick={handleFirstPage} title="First Page">
        <HiChevronDoubleLeft width={16} height={16} />
      </button>
      <StyledPagination
        {...props}
        showSizeChanger={false}
        itemRender={itemRender}
        current={current}
        onChange={onChange}
      />
      <button
        className="icon"
        disabled={current >= lastPage}
        onClick={handleLastPage}
        title="Last Page"
      >
        <HiChevronDoubleRight width={16} height={16} />
      </button>
    </Container>
  );
};

export const Pagination = withTheme(PaginationComponent);
